import { BASE_API_URL } from 'config/configUrl';
import { getAccessToken } from './authProvider';
export const checkSession = async (): Promise<boolean> => {
    try {
      const currentPath = window.location.pathname;
      const excludedPaths = ['/login', '/register', '/forgot-password', '/reset-password', '/recover-password'];
      
      if (excludedPaths.includes(currentPath)) {
          return true;
      }

      const token = getAccessToken();
      if (!token) throw new Error('No token');
  
      const { exp } = JSON.parse(atob(token.split('.')[1])); // decode JWT payload
      const now = Math.floor(Date.now() / 1000);
  
      const timeToExpiry = exp - now;
      // 👇 Si access_token expire dans moins de 2 min, on refresh
      if (timeToExpiry < 120) {
        const response = await fetch(`${BASE_API_URL}/auth/refresh`, {
          method: 'POST',
          credentials: 'include',
        });
  
        if (!response.ok) throw new Error('Refresh failed');
        const auth = await response.json();
        localStorage.setItem("auth", JSON.stringify(auth));
      }
  
      return true;
    } catch (err) {
      console.warn('🔐 Session invalidated:', err);
      localStorage.removeItem('auth');
      return false;
    }
  };
  